import React from 'react';

export default function Logo({ variant = 'dark', size = 'md', showName = true }) {
  const isDark = variant === 'dark';
  const nameColor = isDark ? 'text-slate-900' : 'text-white';
  const subColor = isDark ? 'text-slate-500' : 'text-white/70';
  const nameSize = size === 'lg' ? 'text-[13px]' : 'text-[12px]';
  const logoH = size === 'lg' ? 'h-12' : 'h-11';

  return (
    <div className="flex items-center gap-3">
      <img
        src="/assets/durga-logo.png"
        alt="Durga Facility Management Services Pvt. Ltd."
        className={`${logoH} w-auto object-contain shrink-0`}
      />
      {showName && (
        <div className={`leading-tight hidden sm:block ${nameColor}`}>
          <div className={`font-extrabold ${nameSize} tracking-tight`}>Durga Facility Management</div>
          <div className={`text-[10px] font-semibold uppercase tracking-[0.14em] ${subColor} mt-0.5`}>Services Pvt. Ltd.</div>
        </div>
      )}
    </div>
  );
}
